import styled from '@emotion/styled';
import { Modal } from 'antd';

const StickyModal = styled(Modal)`
  .ant-modal-header {
    position: sticky;
    top: 0;
    z-index: 1;
  }
  .ant-modal-footer {
    position: sticky;
    bottom: 0;
    background: var(--fett-bg-panel);
  }
`;

export default StickyModal;
